module.exports = "<div class=\"confirm-dialog-container\">\n  <div class=\"message-dialog\">\n    <span>{{dialogMessage}}</span>\n  </div>\n  <div class=\"buttons-container\">\n    <button class=\"cancel-button\" (click)=\"cancel()\">Cancel</button>\n    <button class=\"btn-confirm-dialog\" (click)=\"confirm()\">{{confirmationButtonLabel}}</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/finance/confirm-dialog/confirm-dialog.component.html
// module id = 2219
// module chunks = 0